/**
 * Convert hexadecimal color code to rgba format with specified transparency
 * @param hexColor Hexadecimal color code (with or without #)
 * @param transparency Transparency value (0-1)
 * @returns rgba color string
 */
export const set16ToRgba = (str, opacity) => {
  const reg = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
  if (!reg.test(str)) {
    return;
  }
  let newStr = str.toLowerCase().replace(/#/g, '');
  const len = newStr.length;
  if (len === 3) {
    let t = '';
    for (let i = 0; i < len; i++) {
      t += newStr.slice(i, i + 1).concat(newStr.slice(i, i + 1));
    }
    newStr = t;
  }
  const arr = []; // 将字符串分隔，两个两个的分隔
  for (let i = 0; i < 6; i += 2) {
    const s = newStr.slice(i, i + 2);
    arr.push(parseInt(`0x${s}`, 16));
  }
  return `rgba(${arr.join(',')},${opacity})`;
};
